import styled from 'styled-components';
import { font } from 'styles/globals';
import { imageAndTitleLinkHover } from 'styles/imageAndTitleLinkHover';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Card = styled.li<{ theme: Theme }>`
  list-style: none;
  border-bottom: solid 2px ${getColor('borderSecondary')};
  padding: 16px 0 16px 0;

  .section {
    font-family: ${font.graphikCond};
    text-transform: uppercase;
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0.15px;
    margin-bottom: 4px;
  }

  .title-link {
    ${getBodyStyle('graphikCompact', { default: 'default' }, 'semiBold')};
    line-height: 120%;
    display: block;
    margin-bottom: 8px;

    &:hover {
      color: ${getColor('textLink')};
    }
  }
`;

export const Content = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  gap: 8px;

  ${imageAndTitleLinkHover}
`;

export const Left = styled.div<{ theme: Theme }>`
  flex: 1 1 50%;
  width: 70%;
  min-height: 116px;

  &:hover {
    .title {
      color: ${getColor('textLink')};
    }
    & + div {
      .image-link {
        filter: brightness(80%);
      }
    }
  }
  margin-bottom: 8px;
`;

export const Right = styled.div`
  width: 115px;

  &:hover {
    transition: 0.3s ease-in-out;
    .image-link {
      filter: brightness(80%);
    }
  }
`;

export const PublishedDate = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  color: ${getColor('textSecondary')};
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.15px;
  margin-bottom: 0px;
  min-height: 21px;
`;
